<template>
  <Posts :object="object" :params="params" :key="version" />
</template>

<script>
import {defineComponent, onMounted, ref} from "vue"
import Posts from "@/modules/post/pages/posts/components/posts/Posts.vue"
import Default from "@/modules/post/pages/posts/services/NotesNotModerated"

export default defineComponent({
  name: "NotesSiteNotModerated",
  components: {
    Posts
  },
  setup() {
    let version = ref(0)
    let object = new Default()

    function getChannelId() {
      return 1
    }

    let params = {
      title: "Заметки на модерацию",
      h1: "Заметки на модерацию",
      page: "notes_not_moderated",
      type_ids: [5],
      channel_id: getChannelId(),
    }

    onMounted(() => {
      version.value++
    })

    return {
      object,
      params,
      version,
    }
  }
})
</script>

<style scoped>

</style>
